module.exports = _.isObject;